export interface AiAttachment {
    fileId: string;
    name: string;
    url: string;
}

export interface AiStep {
    id: string;
    node?: string;
    displayName?: string;
    status: 'running' | 'done' | 'stopped';
    durationMs?: number;
    startedAt?: number;
}

export type AiMessageStatus =
    | 'streaming'
    | 'completed'
    | 'stopped'
    | 'error';

export enum From {
    USER = 'user',
    ASSISTANT = 'assistant',
}

export interface KBItem {
    id: string;
    title: string;
    type: string;
}

export interface UserPrompt {
    query: string;
}

export enum ActionTypes {
    SHOW_ARTICLE = 'showArticle',
    EMAIL_OPERATOR = 'emailOperator',
    TELEGRAM_BOT = 'telegramBot',
    CONSULTATIONS = 'consultations',
}

export interface Action {
    type: ActionTypes;
    payload?: string;
}

export interface Message {
    id: number;
    from: 'user' | 'assistant';
    text: string;

    // Файлы, возвращаемые новым API
    attachments?: AiAttachment[];

    // Этапы обработки ИИ
    steps?: AiStep[];

    // Состояние потокового ответа
    status?: AiMessageStatus;

    // Оставляем для совместимости со старым кодом
    fileUrl?: string;
    loading?: boolean;
    action?: Action;
    startedAt?: number;
    finishedAt?: number;
}

export enum Tabs {
    CHAT = 'chat',
    LANGUAGE = 'language',
    OPERATOR = 'operator',
}

export interface EmailFormData {
    name: string;
    phoneNumber: string;
    email: string;
    content: string;
}
